import React from 'react';
import { Link } from 'react-router-dom';
import { TbArrowLeft } from 'react-icons/tb';
import { usePageMeta } from '../utils/seo';
// Estilos base (.nvh-*) vêm de Home.css; a faixa azul, de Guia.css.
import './Home.css';
import './Guia.css';

// Qualquer endereço que não existe (inclusive os do site antigo): avisa e pede ao Google para não indexar.
const NotFound = () => {
  usePageMeta({ title: 'Página não encontrada', noindex: true });

  return (
    <div className="nvh nvg">
      <section className="nvg-hero nvg-notfound">
        <div className="nvh-wrap">
          <div className="nvh-eyebrow nvh-eyebrow-gold">Erro 404</div>
          <h1>Página não encontrada</h1>
          <p className="nvg-subtitle">O endereço pode ter mudado ou não existe mais.</p>
          <div className="nvh-actions">
            <Link to="/" className="nvh-btn nvh-btn-gold">
              <TbArrowLeft aria-hidden="true" />
              Voltar ao início
            </Link>
            <Link to="/guias" className="nvh-btn nvh-btn-line">Ver os guias</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
